// extracted by mini-css-extract-plugin
module.exports = {"subrow":"offer-log-details_subrow_XK8hU"};